// @flow
const lego = window.lego

export function toAbsoluteUrl(path: string) {
  return `${lego.config.DOMAIN}${path}`
}
